export const FETCH_DATA_SERVER_ERROR = 'myaxa/life/fetchDataServerError';
export const RESET_SERVER_ERROR = 'myaxa/life/resetServerError';
export const FETCH_PENDING = 'myaxa/life/fetchPending';
export const FETCH_COMPLETE = 'myaxa/life/fetchComplete';

export const initialState = {
  isServerError: false,
  isLoading: true,
  apiHasBeenCalled: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_DATA_SERVER_ERROR:
      return {
        ...state,
        isServerError: true,
        isLoading: false,
      };
    case RESET_SERVER_ERROR:
      return {
        ...state,
        isServerError: false,
      };
    case FETCH_PENDING:
      return {
        ...state,
        isLoading: true,
        apiHasBeenCalled: false,
      };
    case FETCH_COMPLETE:
      return {
        ...state,
        isLoading: false,
        apiHasBeenCalled: true,
      };
    default:
      return state;
  }
}

export function resetServerError() {
  return { type: RESET_SERVER_ERROR };
}
